import request from '../utils/http'
const appid = 2001  // 维应SPR海外版

// 760 修改特别用户资料
export function updateUserInfo(data) {
    return request({
        url: "/service/view04/special_user_Hand.ashx",  //接口路径
        method: "post",  //接口方法
        // headers: { 'Content-Type':'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "special_useredit",
           ...data
        }  //接口参数
    })
}

// 修改用户 姓名/手机号 325
export function updateUserNameTel(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "upuser2",
            ...data 
        }  //接口参数
    })
}

// 修改用户扩展信息 143
export function updateUserExtInfo(data) {
    return request({
        url: "/service/farming.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_farming_user_ext_edit",
            ...data 
        }  //接口参数
    })
}


// 修改用户昵称头像 3
export function updateUserNickTx(data) {
    return request({
        url: "/service_app/saveuser.aspx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            appid,
            ...data
        }  //接口参数
    })
}
